import React from 'react'
import ExperienceCards from './ExperienceCards'

const ExperienceTab = () => {
  return (
    <div className="pt-24 pb-12 px-4 min-h-screen text-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold mb-4 font-serif bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-pink-600 inline-block">
            WORK EXPERIENCE
          </h2>
          <div className="h-1 w-24 bg-gradient-to-r from-purple-500 to-pink-500 mx-auto rounded-full"></div>
        </div>

        <ExperienceCards />
      </div>
    </div>
  )
}

export default ExperienceTab